import { useTranslation } from "react-i18next";
import { useMemo, useState } from "react";
import WoodBoxIcon from "../../../../../assets/icons/woodBox.svg?react";
import { UpdateGlobalParameterDto } from "../../../../../types/api/api-types";
import { WoodboxPriceGroup, WoodboxProps } from "../../../../../types/forms/woodbox.form";
import { OptionsWoodboxItem } from "./optionsWoodboxItem";
import { OptionsWoodboxModal } from "./optionsWoodboxModal";

export const ParameterWoodBox = ({ woodBoxesPrice }: WoodboxProps) => {
  const { t } = useTranslation("boParameters");
  const [editWoodBox, setEditWoodBox] = useState<UpdateGlobalParameterDto["woodBoxesPrice"] | null>(
    null,
  );

  const GroupWoodboxes: WoodboxPriceGroup[] = useMemo(() => {
    if (!woodBoxesPrice) return [];
    return Object.values(
      woodBoxesPrice.reduce(
        (acc, item) => {
          const { region, bottleVolume } = item;
          const groupKey = `${region}-${bottleVolume}`;
          if (!acc[groupKey]) {
            acc[groupKey] = { region, bottleVolume, items: [] };
          }

          acc[groupKey].items.push(item);
          return acc;
        },
        {} as Record<
          string,
          { region: string; bottleVolume: number; items: typeof woodBoxesPrice }
        >,
      ),
    )
      .map((group) => ({
        region: group.region,
        bottleVolume: group.bottleVolume,
        items: group.items.sort((a, b) => Number(a.bottleQuantity) - Number(b.bottleQuantity)),
      }))
      .sort((a: WoodboxPriceGroup, b: WoodboxPriceGroup) => {
        const volumeComparison = a.bottleVolume - b.bottleVolume;
        if (volumeComparison === 0) {
          return a.region.localeCompare(b.region);
        }
        return volumeComparison;
      });
  }, [woodBoxesPrice]);

  return (
    <div className="flex w-full max-w-[600px] flex-col gap-2 rounded-xl border border-gray-200 bg-white p-6">
      <div className="flex flex-row justify-between gap-4">
        <div className="flex w-fit flex-row items-center gap-4">
          <WoodBoxIcon className="text-black" width={24} height={24} />
          <div className="flex flex-1 flex-col">
            <h3 className="text-lg font-semibold text-black">{t("woodboxOption.title")}</h3>
          </div>
        </div>
      </div>
      {GroupWoodboxes.map((group: WoodboxPriceGroup, index: number) => (
        <OptionsWoodboxItem
          group={group}
          index={index}
          key={index}
          setEditWoodBox={setEditWoodBox}
        />
      ))}
      {editWoodBox && (
        <OptionsWoodboxModal
          closeModal={() => setEditWoodBox(null)}
          title={t("woodboxOption.modalTitle")}
          woodBoxesPrice={editWoodBox}
        />
      )}
    </div>
  );
};
